import React from "react";
import type { SceneMeta } from "../../api";
import { Tooltip } from "./Tooltip";

type Props = {
  scenes: SceneMeta[];
  onAdd: (s: SceneMeta) => void;
  /** Adds a free-floating editable text overlay at the playhead position. */
  onAddText?: () => void;
};

/** Most-useful scenes to add with one click — saves scrolling the library. */
const TOP_HITS: { id: string; emoji: string; label: string }[] = [
  { id: "kineticHook", emoji: "💥", label: "Hook" },
  { id: "wordMorph", emoji: "🔤", label: "Word-Morph" },
  { id: "glassCard", emoji: "🪟", label: "Glass-Card" },
  { id: "numberOdometer", emoji: "🔢", label: "Counter" },
  { id: "chartPop", emoji: "📊", label: "Bar-Chart" },
  { id: "swipeStack", emoji: "🃏", label: "Swipe-Cards" },
  { id: "phoneCarousel", emoji: "📱", label: "Phone" },
  { id: "tickerStrip", emoji: "📈", label: "Ticker" },
  { id: "floatingLabels", emoji: "✨", label: "Float-Labels" },
  { id: "testimonialCard", emoji: "💬", label: "Testimonial" },
  { id: "priceCompare", emoji: "⚖️", label: "Price-Vs" },
  { id: "qrCardFlip", emoji: "🔗", label: "QR-Outro" },
];

export const QuickAddBar: React.FC<Props> = ({ scenes, onAdd, onAddText }) => {
  const map = new Map(scenes.map((s) => [s.id, s]));
  return (
    <div className="quick-add-bar">
      <Tooltip
        title="Quick-Add-Leiste"
        description="Klick auf eine Scene → wird ans Ende der Timeline gesetzt und im Inspector aktiviert. Für die volle Auswahl nutze die Scene-Library links."
      >
        <span className="quick-add-label" data-tip-host="true">⚡ Quick-Add</span>
      </Tooltip>
      <div className="quick-add-list">
        {onAddText ? (
          <Tooltip
            title="🅣 Text-Layer"
            description="Fügt einen frei beweglichen Text auf die Timeline. Im Vorschau-Bild ziehen, drehen, skalieren · Doppelklick zum Editieren."
            shortcut="T"
          >
            <button
              className="quick-add-btn quick-add-text-btn"
              onClick={() => onAddText()}
              data-tip-host="true"
            >
              <span className="quick-add-emoji">🅣</span>
              <span className="quick-add-text">Text</span>
            </button>
          </Tooltip>
        ) : null}
        {TOP_HITS.map((hit) => {
          const scene = map.get(hit.id);
          if (!scene) return null;
          return (
            <Tooltip
              key={hit.id}
              title={`${hit.emoji} ${scene.label}`}
              description={`${scene.description} · Default-Dauer ${scene.defaultDurationSec}s. Klick = Hinzufügen.`}
            >
              <button
                className="quick-add-btn"
                onClick={() => onAdd(scene)}
                data-tip-host="true"
              >
                <span className="quick-add-emoji">{hit.emoji}</span>
                <span className="quick-add-text">{hit.label}</span>
              </button>
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
};
